module.exports = __webpack_public_path__ + "img/img-404-text.5caf8e11.png";